import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import importListHelper from '../../../Helpers/importListHelper';
import selectHelper from '../../../Helpers/selectHelper';
import UserService from '../../../Services/userService';

export default class EvaluatorSearchParams extends SearchParamsBase {
  initialize() {
    const userOffice = UserService.GetOfficeIdOfLoggedInUser();
    this.FieldworkOfficeIds = OfficeHelper.GetDefaultOfficeIds(userOffice);
    this.PaymentOfficeIds = OfficeHelper.GetDefaultOfficeIds(userOffice);
    this.Id = '';
    this.Agency = '';
    this.Name = '';
    this.Email = '';
    this.PhoneNumber1 = '';
    this.PhoneNumber2 = '';
    this.SelectedCitizenships = [];
    this.SelectedBusinesses = [];
    this.SelectedLanguages = [];
    this.SelectedVehicles = [];
    this.SelectedCountries = [];
    this.EvaluatorExtendedEvexRegBusiness = [];
    this.EvaluatorExtendedEvexVehicle = [];
    this.EvaluatorExtendedEvexTablet = [];
    this.SSN = '';
    this.SelectedSsnStatuses = [];
    this.SelectedEvaluatorStatuses = [];
    this.EmailOptOut = '';
    this.EmailVerified = '';
    this.TipaltiPayable = '';
    this.SelectedTipaltiInvitedStatuses = [];
    this.SelectedRatings = [];
    this.SelectedGender = '';
    this.FromAge = '';
    this.ToAge = '';
    this.TextAllow = '';
    this.ApolloLanguages = [];
    this.States = '';
    this.ZipCodes = '';
    this.Cities = '';
    this.UseSignUpDateRange = false;
    this.SignUpStartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.SignUpEndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.UseLastCompletedShopDateRange = false;
    this.LastCompletedShopStartDate = dateTimeHelper.firstDayOfTheActualMonth();
    this.LastCompletedShopEndDate = dateTimeHelper.lastDayOfTheActualMonth();
    this.HasAssignments = null;
    this.AssignmentsInLastMonths = null;
    this.ExcludeCountry = null;
    this.ExcludeCitizenship = null;
  }

  static tabsOnTheSearchPanel = [
    { label: 'Base', id: 'base', icon: 'fa-solid fa-baseball' },
    { label: 'Properties', id: 'properties', icon: 'fa-solid fa-car' },
    { label: 'Personal', id: 'personal', icon: 'fa-solid fa-person' },
    { label: 'Other', id: 'other', icon: 'fa-solid fa-clothes-hanger' },
  ];

  static fieldsInSearchBox = [
    {
      fieldName: 'Id',
      label: 'Apollo or Caspian Ids',
      className: 'col-4',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'base',
    },
    { fieldName: 'Name', label: 'Name', className: 'col-4', type: InputTypesEnum.Text, tab: 'base' },
    { fieldName: 'Email', label: 'Email', className: 'col-4', type: InputTypesEnum.Email, tab: 'base' },
    {
      fieldName: 'FieldworkOfficeIds',
      label: 'Fieldwork Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      roleKey: 'evaulator_inputfield_EvaluatorGlobalView',
      tab: 'base',
    },
    {
      fieldName: 'PaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
      roleKey: 'evaulator_inputfield_EvaluatorGlobalView',
      tab: 'base',
    },
    { fieldName: 'PhoneNumber1', label: 'Phone 1', className: 'col-4', type: InputTypesEnum.Text, tab: 'base' },
    { fieldName: 'PhoneNumber2', label: 'Phone 2', className: 'col-4', type: InputTypesEnum.Text, tab: 'base' },
    { fieldName: 'Agency', label: 'Agency', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect, tab: 'base' },
    { fieldName: 'SSN', label: 'SSN', className: 'col-4', type: InputTypesEnum.Text, tab: 'base' },
    {
      fieldName: 'SelectedSsnStatuses',
      label: 'SSN Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getSSNStatusOptionsFunction(),
      tab: 'base',
    },

    {
      fieldName: 'EvaluatorExtendedEvexRegBusiness',
      label: 'Owns a Registered Business',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getOwnStatusOptionsFunction(),
      tab: 'properties',
    },
    {
      fieldName: 'EvaluatorExtendedEvexVehicle',
      label: 'Owns a Vehicle',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getOwnStatusOptionsFunction(),
      tab: 'properties',
    },
    {
      fieldName: 'ExcludeCitizenship',
      label: 'Exclude/Include Citizenship Selection',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: EvaluatorSearchParams.getExcludeIncludeSelectOptions(),
      tab: 'properties',
    },
    {
      fieldName: 'SelectedBusinesses',
      label: 'Business Classification',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 99,
      showCondition: (searchItem) =>
        searchItem.EvaluatorExtendedEvexRegBusiness.length === 1 &&
        searchItem.EvaluatorExtendedEvexRegBusiness[0] === 'Yes',
      tab: 'properties',
    },
    {
      fieldName: 'SelectedVehicles',
      label: 'Vehicle Type',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      showCondition: (searchItem) =>
        searchItem.EvaluatorExtendedEvexVehicle.length === 1 && searchItem.EvaluatorExtendedEvexVehicle[0] === 'Yes',
      options: 102,
      tab: 'properties',
    },
    {
      fieldName: 'SelectedCitizenships',
      label: 'Citizenship',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 101,
      tab: 'properties',
    },
    {
      fieldName: 'EvaluatorExtendedEvexTablet',
      label: 'Owns a Tablet',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getOwnStatusOptionsFunction(),
      tab: 'properties',
    },

    {
      fieldName: 'SelectedGender',
      label: 'Gender',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: EvaluatorSearchParams.getGenderSelectOptions(),
      tab: 'personal',
    },
    { fieldName: 'AgeFrom', label: 'Age From', className: 'col-3', type: InputTypesEnum.Number, tab: 'personal' },
    { fieldName: 'AgeTo', label: 'Age To', className: 'col-3', type: InputTypesEnum.Number, tab: 'personal' },
    {
      fieldName: 'ApolloLanguages',
      label: 'Apollo Language',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getApolloLanguages(),
      tab: 'personal',
    },
    {
      fieldName: 'ExcludeCountry',
      label: 'Exclude/Include Country Selection',
      className: 'col-3',
      type: InputTypesEnum.Select,
      options: EvaluatorSearchParams.getExcludeIncludeSelectOptions(),
      tab: 'personal',
    },
    {
      fieldName: 'SelectedCountries',
      label: 'Country',
      className: 'col-3',
      type: InputTypesEnum.CountryCodeMultiChoice,
      tab: 'personal',
    },
    {
      fieldName: 'States',
      label: 'States (state1, state2, ...)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'personal',
      showCondition: (searchItem) => searchItem.SelectedCountries.length > 0,
    },
    {
      fieldName: 'ZipCodes',
      label: 'Zip Codes',
      className: 'col-3',
      type: InputTypesEnum.TextList,
      tooltipText: importListHelper.ListFieldTooltip,
      tab: 'personal',
      showCondition: (searchItem) => searchItem.SelectedCountries.length > 0,
    },
    {
      fieldName: 'Cities',
      label: 'Cities (city1, city2, ...)',
      className: 'col-3',
      type: InputTypesEnum.Text,
      tab: 'personal',
      showCondition: (searchItem) => searchItem.SelectedCountries.length > 0,
    },

    {
      fieldName: 'SelectedEvaluatorStatuses',
      label: 'Evaluator Status',
      className: 'col-3',
      type: InputTypesEnum.LookupMultiChoice,
      options: 40,
      tab: 'other',
    },
    {
      fieldName: 'EmailOptOut',
      label: 'Opted out from emails?',
      className: 'col-2',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'other',
    },
    {
      fieldName: 'EmailVerified',
      label: 'Email Verified?',
      className: 'col-2',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'other',
    },
    {
      fieldName: 'TipaltiPayable',
      label: 'Tipalti Payable',
      className: 'col-2',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'other',
    },
    {
      fieldName: 'SelectedTipaltiInvitedStatuses',
      label: 'Tipalti Invited',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getTipaltiInvitedStatusesFunction(),
      tab: 'other',
    },
    {
      fieldName: 'SelectedRatings',
      label: 'Rating',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: EvaluatorSearchParams.getRatingOptionsFunction(),
      tab: 'other',
    },
    {
      fieldName: 'TextAllow',
      label: 'Text Message Authorized?',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: EvaluatorSearchParams.getTextAllowOptions(),
      tab: 'other',
    },
    {
      fieldName: 'SelectedLanguages',
      label: 'Languages Fluent in',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 98,
      tab: 'other',
    },
    {
      fieldName: 'UseSignUpDateRange',
      label: 'Use Sign-Up Date Range?',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
      tab: 'other',
    },
    {
      fieldName: 'SignUpStartDate',
      label: 'Sign-Up Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseSignUpDateRange,
      tab: 'other',
    },
    {
      fieldName: 'SignUpEndDate',
      label: 'Sign-Up End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseSignUpDateRange,
      tab: 'other',
    },
    {
      fieldName: 'UseLastCompletedShopDateRange',
      label: 'Use Last Completed Shop Date Range?',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
      tab: 'other',
    },
    {
      fieldName: 'LastCompletedShopStartDate',
      label: 'Last Completed Shop Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseLastCompletedShopDateRange,
      tab: 'other',
    },
    {
      fieldName: 'LastCompletedShopEndDate',
      label: 'Last Completed Shop End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseLastCompletedShopDateRange,
      tab: 'other',
    },
    {
      fieldName: 'HasAssignments',
      label: 'Has Assignments?',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
      tab: 'other',
    },
    {
      fieldName: 'AssignmentsInLastMonths',
      label: "Had assignments in the last 'N' months",
      className: 'col-4',
      type: InputTypesEnum.Number,
      tab: 'other',
      showCondition: (searchItem) => searchItem.HasAssignments === 'true',
    },
  ];

  static getExcludeIncludeSelectOptions() {
    return [
      { label: '', value: null, disabled: false },
      { label: 'Include', value: false, disabled: false },
      { label: 'Exclude', value: true, disabled: false },
    ];
  }

  static getGenderSelectOptions() {
    return selectHelper.generateSelectValues(['', 'Male', 'Female']);
  }

  static getRatingOptionsFunction() {
    return selectHelper.generateSelectValues(['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'No Rating']);
  }

  static getOwnStatusOptionsFunction() {
    return selectHelper.generateSelectValues(['No Response', 'Yes', 'No', 'No Information']);
  }

  static getTextAllowOptions() {
    return selectHelper.generateSelectValues(['', 'Yes', 'No', 'N/A']);
  }

  static getApolloLanguages() {
    return [
      { label: 'Dutch', value: 137, disabled: false },
      { label: 'English', value: 25, disabled: false },
      { label: 'French', value: 34, disabled: false },
      { label: 'German', value: 22, disabled: false },
      { label: 'Hungarian', value: 55, disabled: false },
      { label: 'Italian', value: 51, disabled: false },
      { label: 'Japanese', value: 53, disabled: false },
      { label: 'Korean', value: 61, disabled: false },
      { label: 'Mandarin', value: 135, disabled: false },
      { label: 'Portuguese', value: 90, disabled: false },
      { label: 'Russian', value: 95, disabled: false },
      { label: 'Spanish', value: 27, disabled: false },
      { label: 'Traditional Chinese', value: 138, disabled: false },
    ];
  }

  static getSSNStatusOptionsFunction() {
    return selectHelper.generateSelectValues([
      'MISSING',
      'VERIFIED',
      'VERIFIED_ALT',
      'VERIFIED_ALT_APPROVED',
      'DEFERRED',
      'PENDING',
      'NO_SSN',
      'NO_SSN_APPROVED',
      'INVALID',
      'NO_SSN_DISAPPROVED',
      'VERIFIED_ALT_DISAPPROVED',
    ]);
  }

  static getTipaltiInvitedStatusesFunction() {
    return selectHelper.generateSelectValues([
      'Not Invited',
      'Invited',
      'Not Registered',
      'Registered',
      'No Information',
    ]);
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'EvaluatorSearchParams';

  static valuesToEraseOnChange = {
    // values: [["EvaluatorExtendedEvexVehicle", "SelectedVehicles"], ["EvaluatorExtendedEvexRegBusiness", "SelectedBusinesses"]]
    values: [
      { triggerField: 'EvaluatorExtendedEvexVehicle', toErase: 'SelectedVehicles', value: [] },
      { triggerField: 'EvaluatorExtendedEvexRegBusiness', toErase: 'SelectedBusinesses', value: [] },
    ],
  };
}
